import React from "react";
import { Result, Button } from "antd";

const Exception = (props) => {
  const { errorCode, message } = props;
  return <Result status={errorCode} subTitle={message} />;
};

export default Exception;
